import React from 'react';
import ShoppingCart from '../cta/shopping_cart';

const CartPage: React.FC = () => {
  return (
    <div>
      <main>
        <ShoppingCart />
      </main>
    </div>
  );
};

export default CartPage;
